import { render, staticRenderFns } from "./ActivationBriefAffiliateLinksView.vue?vue&type=template&id=91ff4c54&scoped=true&"
import script from "./ActivationBriefAffiliateLinksView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefAffiliateLinksView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ff4c54",
  null
  
)

export default component.exports